if(!customElements.get('delivery-estimate-banner-cart')){
    customElements.define(
      "delivery-estimate-banner-cart",
      class DeliveryEstimateBanner extends HTMLElement {
        constructor() {
          super();
          this.message = this.querySelector("[data-message]");
          this.standardMessage = this.querySelector('[data-standard-message]');
          this.standardMessageContainer = this.querySelector('[data-standard-message-container]');
          this.dataContainer = this.querySelector("[data-delivery-data]");
          this.data = {};
        }
        connectedCallback() {
          try {
            this.data = JSON.parse(this.dataContainer.innerHTML);
            this.init();
          } catch (e) {
            this.hide();
          }
        }
        hide() {
          this.setAttribute("hidden", true);
        }
        show() {
          this.removeAttribute("hidden");
        }
        hideStandardDelivery(){
          this.standardMessageContainer.setAttribute("hidden", true);
        }
        showStandardDelivery(){
          this.standardMessageContainer.removeAttribute('hidden');
        }
        init() {
          if (this.data.cartData.length < 1) {
            return this.hide();
          }
          this.calculateMessage();
          if(this.standardMessage != null){
            if (!this.hasNextDayDelivery()) {
              this.hideStandardDelivery();
            } else {
              this.calculateStandardMessage();
            }
          }
        }
        hasNextDayDelivery(){
          let outOfStockAtMain = this.data.cartData.filter((item) => !item.main);
          if (outOfStockAtMain.length > 0) {
            //some items are out of stock at main warehouse
           return false
          } else {
            return true;
          }
        }
        calculateStandardMessage(){
          //get all supplier messages
          //show the worst one
          let highestMessage = this.getSupplierMessage(this.data.cartData);
          if (highestMessage != "") {
            this.standardMessage.innerText = highestMessage;
            this.showStandardDelivery();
          }
        }
        calculateMessage() {
          // if all items are in stock at main
          //  show delivery calculation
          //if any are out of stock at main
          // get a list of messages and display worst possible outcome

          let outOfStockAtMain = this.data.cartData.filter((item) => !item.main);
          if (outOfStockAtMain.length > 0) {
            //some items are out of stock at main warehouse
            this.showSupplierMessage(outOfStockAtMain);
          } else {
            this.showMainDeliveryMessage();
          }
        }
        getSupplierMessage(variantData){
          let highestDay = 0;
          let highestMessage = "";
          let allSupplierMessages = variantData.map((item) => {
            if (!item.supplier) {
              if (item.variantSupplierMessage != "") {
                return item.variantSupplierMessage;
              }
              return "";
            }
            return item.supplierDefaultMessage;
          });
          //get the first number in the message
          if (allSupplierMessages.length == 1) {
            highestMessage = allSupplierMessages[0];
          } else {
            allSupplierMessages.forEach((message) => {
              let firstNumber = this.getFirstNumberInString(message);
              if (firstNumber != null) {
                if (firstNumber > highestDay) {
                  highestDay = firstNumber;
                  highestMessage = message;
                }
              }
            });
          }
          return highestMessage;
        }
        showSupplierMessage(outOfStockAtMain) {
          let highestMessage = this.getSupplierMessage(outOfStockAtMain);
          if (highestMessage == "") {
            return this.hide();
          }
          this.message.innerText = highestMessage;
          this.show();
        }
        getFirstNumberInString(string) {
          let number = null;
          let matches = string.match(/\d+/g);
          if (matches) {
            number = matches[0];
          }
          return number;
        }
        showMainDeliveryMessage() {
          let message = this.generateDeliveryMessage();

          if (message == "") {
            return this.hide();
          }
          this.message.innerText = message;
          this.updateCartAttribute(message);
          this.show();
        }
        getThreeLetterDay(dateObj) {
          let options = { weekday: "short" };
          return new Intl.DateTimeFormat("en-GB", options).format(dateObj);
        }
        getYmdDate(dateObj) {
          return dateObj.toISOString().split("T")[0];
        }
        getNiceDate(dateObj) {
          let day = dateObj.getDate();
          let month = dateObj.toLocaleString("default", { month: "long" });
          let dayOfWeek = dateObj.toLocaleString("default", { weekday: "long" });

          const nthNumber = (number) => {
            if (number > 3 && number < 21) return "th";
            switch (number % 10) {
              case 1:
                return "st";
              case 2:
                return "nd";
              case 3:
                return "rd";
              default:
                return "th";
            }
          };

          return `${dayOfWeek} ${day}${nthNumber(day)} ${month}`;
        }
        getNextDispatchDate() {
          let todaysDate = new Date();
          let nextDispatchDate = new Date();
          if (todaysDate.getHours() >= this.data.cutoffHour) {
            //next dispatch is tomorrow
            nextDispatchDate.setDate(nextDispatchDate.getDate() + 1);
          }
          nextDispatchDate = this.getNextAvailableDate(nextDispatchDate);
          return nextDispatchDate;
        }
        getNextAvailableDate(dateObj) {
          while (this.data.undeliverableDays.includes(this.getThreeLetterDay(dateObj)) || this.data.undeliverableDates.includes(this.getYmdDate(dateObj))) {
            dateObj.setDate(dateObj.getDate() + 1);
          }
          return dateObj;
        }
        getNextDeliveryDate(dispatchDate) {
          let leadTime = parseInt(this.data.deliveryLeadTime);
          let nextDeliveryDate = new Date(dispatchDate.getTime());
          nextDeliveryDate.setDate(nextDeliveryDate.getDate() + leadTime);
          nextDeliveryDate = this.getNextAvailableDate(nextDeliveryDate);
          return nextDeliveryDate;
        }
        generateDeliveryMessage() {
          let deliveryMessage = "";
          let nextDispatchDate = this.getNextDispatchDate();
          let nextDeliveryDate = this.getNextDeliveryDate(nextDispatchDate);

          //convert date object to readable string
          deliveryMessage = this.getNiceDate(nextDeliveryDate);
          return deliveryMessage;
        }
        updateCartAttribute(message) {
          let formData = new FormData();
          formData.append("attributes[_estimated_delivery_date]", message);

          fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            body: formData,
          }).catch((err) => console.error(err));
        }
      }
    );
}